import * as Sentry from '@sentry/react';
import { useTranslation } from 'react-i18next';
import { useWorkspaceContext } from '../../providers/WorkspaceProvider/Workspace.context.ts';
import ChatContent from './Chat.content.tsx';
import ChatProvider from './Chat.context.tsx';
import ChatSearchProvider from './components/ChatSearch/ChatSearch.provider.tsx';
import './Chat.styles.scss';
import { tChatProps } from './Chat.types.ts';
import WapiPlanSendGuardProvider from './WapiPlanSendGuard.provider';

function ChatWithBoundary(props: tChatProps) {
  const { t } = useTranslation(['chat/chat']);
  const { currentWorkspace } = useWorkspaceContext();

  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError, eventId }) => (
        <div className="flex flex-col items-center justify-center h-full gap-4">
          <p className="text-base-content/60">
            {t('error.message', 'Algo salio mal en el chat.')}
          </p>
          <button className="btn btn-primary btn-sm" onClick={resetError}>
            {t('error.retry', 'Reintentar')}
          </button>
          <p className="text-xs text-base-content/30">ID: {eventId}</p>
        </div>
      )}
      beforeCapture={(scope) => {
        scope.setTag('error_boundary', 'chat_panel');
        scope.setTag('workspace_id', currentWorkspace?.id ?? 'unknown');
        scope.setLevel('error');
      }}
    >
      <ChatContent {...props} />
    </Sentry.ErrorBoundary>
  );
}

export default function Chat(props: tChatProps) {
  return (
    <WapiPlanSendGuardProvider>
      <ChatProvider>
        <ChatSearchProvider>
          <ChatWithBoundary {...props} />
        </ChatSearchProvider>
      </ChatProvider>
    </WapiPlanSendGuardProvider>
  );
}
